import { render, staticRenderFns } from "./AdDetails.vue?vue&type=template&id=3b912458&scoped=true"
import script from "./AdDetails.vue?vue&type=script&lang=js"
export * from "./AdDetails.vue?vue&type=script&lang=js"
import style0 from "./AdDetails.vue?vue&type=style&index=0&id=3b912458&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b912458",
  null
  
)

export default component.exports